import axios from 'axios';
import { createBaseAPIConfig } from '@/config/api';
import { handleError, getToken } from './request';

// 创建基础服务的 axios 实例
const baseAPI = axios.create(createBaseAPIConfig());

// 添加请求拦截器，统一处理token
baseAPI.interceptors.request.use(
  (config) => {
    const token = getToken();
    if (token) {
      // 认证统一通过请求头传递，避免凭据进入浏览器历史和代理日志。
      config.headers['token'] = token;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// 添加响应拦截器，处理token失效的情况
baseAPI.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (error.response && error.response.status === 401) {
      // token失效，清除认证信息并跳转到登录页
      import('./request').then(({ clearAuthData }) => {
        clearAuthData();
        window.location.href = '/login';
      });
    }
    return Promise.reject(error);
  }
);

// 基础服务请求方法
export const baseRequest = {
  async get(url, params = {}) {
    try {
      const response = await baseAPI.get(url, { params });
      return response.data;
    } catch (error) {
      const message = handleError(error);
      throw new Error(message);
    }
  },
  
  async post(url, data = {}, config = {}) {
    try {
      const response = await baseAPI.post(url, data, config);
      return response.data;
    } catch (error) {
      const message = handleError(error);
      throw new Error(message);
    }
  }
};
